import { render, staticRenderFns } from "./file-icons.vue?vue&type=template&id=86620a9a&"
import script from "./file-icons.vue?vue&type=script&lang=js&"
export * from "./file-icons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports